import { Link, router } from 'expo-router';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { AppChromeShell } from '@/src/components/AppChromeShell';
import { Button } from '@/src/components/Button';
import { InternalNotFound } from '@/src/components/InternalNotFound';
import { PublicPageShell } from '@/src/components/PublicPageShell';
import { useAuth } from '@/src/features/auth/use-auth';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

export default function NotFoundScreen() {
  const { user } = useAuth();
  const primaryHref = user ? '/home' : '/sign-in';
  const primaryTitle = user ? 'Go to Home' : 'Go to sign in';

  if (user) {
    return (
      <AppChromeShell>
        <InternalNotFound />
      </AppChromeShell>
    );
  }

  return (
    <PublicPageShell title="Page not found">
      <View style={styles.card}>
        <Text style={styles.errorCode}>404</Text>
        <Text style={styles.title}>This Frienzzi page is not available.</Text>
        <Text style={styles.body}>
          The link may be old, the page may have moved, or the content may no
          longer be available.
        </Text>
        <View style={styles.actions}>
          <Link href={primaryHref} asChild>
            <Button title={primaryTitle} style={styles.actionButton} />
          </Link>
          {router.canGoBack() ? (
            <Button
              title="Go back"
              variant="secondary"
              style={styles.actionButton}
              onPress={() => router.back()}
            />
          ) : null}
        </View>
      </View>
      <View style={styles.links}>
        <Link href="/mission" asChild>
          <Pressable accessibilityRole="link" style={styles.linkButton}>
            <Text style={styles.linkText}>Mission Statement</Text>
          </Pressable>
        </Link>
        <Link href="/changelog" asChild>
          <Pressable accessibilityRole="link" style={styles.linkButton}>
            <Text style={styles.linkText}>Public Changelog</Text>
          </Pressable>
        </Link>
        <Link href="/install" asChild>
          <Pressable accessibilityRole="link" style={styles.linkButton}>
            <Text style={styles.linkText}>Install Frienzzi</Text>
          </Pressable>
        </Link>
      </View>
    </PublicPageShell>
  );
}

const styles = StyleSheet.create({
  actionButton: {
    flexGrow: 1,
  },
  actions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
    width: '100%',
  },
  body: {
    color: colors.mutedText,
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
  },
  card: {
    alignItems: 'center',
    backgroundColor: colors.surface,
    borderColor: colors.border,
    borderRadius: 16,
    borderWidth: 1,
    gap: spacing.lg,
    padding: spacing.xl,
  },
  errorCode: {
    color: colors.primary,
    fontSize: 72,
    fontWeight: '900',
    letterSpacing: 0,
    lineHeight: 80,
  },
  linkButton: {
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
  },
  links: {
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    justifyContent: 'center',
  },
  linkText: {
    color: colors.secondary,
    fontSize: 15,
    fontWeight: '800',
  },
  title: {
    color: colors.text,
    fontSize: 24,
    fontWeight: '900',
    textAlign: 'center',
  },
});
